<template>
  <div class="my-3">
    <p class="mb-0 font-weight-bold">Docket File Number</p>
    <input :value="statusDetails" class="form-control form-control-sm" type="text"
           @change="(event) => updateStatus(event.target.value)">
  </div>
</template>

<script>
import {addOrUpdateParameter} from "@/helpers/urlParamsHelper";

export default {
  name: "DocketFileNumber",

  computed: {
    statusDetails: function () {
      return this.$store.getters["search/getDocketFileNumber"];
    }
  },

  methods: {
    updateStatus(value) {
      this.$store.dispatch('search/updateDocket_File_Number', value);

      // Adds the new value as parameters to the URI
      const encodedParams = encodeURI(value);
      addOrUpdateParameter("docket_file_number", encodedParams);
    }
  }
}
</script>